import { FormHelperText, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getIn } from 'formik';
import React, { FC, Fragment, MouseEvent } from 'react';

interface IToggleProps {
  options: string[];
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  field: any;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  form: any;
}

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  textTransform: 'capitalize',

  '&.Mui-selected': {
    background: theme.palette.primary.main,
    fontWeight: 600,
    color: theme.palette.common.white,
  },

  '&.MuiToggleButton-root': {
    padding: theme.spacing(0.8),
    fontSize: 12,
    textTransform: 'none',
  },

  '&:hover.Mui-selected': {
    background: '#5B9FFF',
    color: theme.palette.common.white,
  },
}));

const Toggle: FC<IToggleProps> = ({ options, ...props }) => {
  const {
    field: { value, name },
    form: { setFieldValue, errors, touched, validateOnMount },
  } = props;

  const fieldError = getIn(errors, name);
  const showError = (getIn(touched, name) || validateOnMount) && !!fieldError;

  const handleChange = (e: MouseEvent<HTMLElement>, value: string | null) => {
    if (value !== null) {
      setFieldValue(name, value);
    }
  };

  return (
    <Fragment>
      <ToggleButtonGroup value={value} exclusive onChange={handleChange}>
        {options.map(value => (
          <StyledToggleButton color="primary" value={value} key={value}>
            {value}
          </StyledToggleButton>
        ))}
      </ToggleButtonGroup>
      {showError && <FormHelperText error>{fieldError}</FormHelperText>}
    </Fragment>
  );
};

export default Toggle;
